module.exports = __webpack_public_path__ + "img/Niehaus@3x.3be026ea.webp";